import { render, staticRenderFns } from "./ProjectComponent.vue?vue&type=template&id=676f9256&scoped=true&"
import script from "./ProjectComponent.vue?vue&type=script&lang=ts&"
export * from "./ProjectComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectComponent.vue?vue&type=style&index=0&id=676f9256&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f9256",
  null
  
)

export default component.exports